export class CanvasGraphics {
    constructor(canvas) {
        this.canvas = canvas;
        const context = canvas.getContext('2d');
        if (!context) {
            throw new Error('Failed to get 2D context from canvas');
        }
        this.ctx = context;
    }
    createSurface(width, height) {
        const data = this.ctx.createImageData(width, height);
        return { width, height, data };
    }
    present(surface) {
        this.ctx.putImageData(surface.data, 0, 0);
    }
    clear(color) {
        this.ctx.fillStyle = this.colorToCSS(color);
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    }
    drawRect(rect, color) {
        this.ctx.fillStyle = this.colorToCSS(color);
        this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
    }
    drawText(text, pos, font, color) {
        this.ctx.font = `${font.size}px ${font.family}`;
        this.ctx.fillStyle = this.colorToCSS(color);
        this.ctx.fillText(text, pos.x, pos.y);
    }
    drawImage(image, pos) {
        this.ctx.putImageData(image, pos.x, pos.y);
    }
    setGlobalAlpha(alpha) {
        this.ctx.globalAlpha = alpha;
    }
    colorToCSS(color) {
        return `rgb(${color.r}, ${color.g}, ${color.b})`;
    }
}
